import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environment/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AboutUsModel } from '../Model/aboutUs.model';
import { SettingsModel } from '../../../shared/Model/setting.model';
import { SharedApiService } from '../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class AboutService {

  private endpoint1 = `AboutUs/GetAll`
  private endpoint2 = `Setting/GetAll`

  private sharedApiService = inject(SharedApiService)

  getAll(): Observable<{ value: AboutUsModel[] }> {
    return this.sharedApiService.getAll(this.endpoint1);
  }

  getAllSettings(): Observable<{ value: SettingsModel[] }> {
    return this.sharedApiService.getAll(this.endpoint2);
  }
}
